import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/leave-initial-balances',
    name: 'leave-initial-balance',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/leave-initial-balance/index.vue')
  }
]
